(() => {
  angular.module('app').component('hostInpatientGuaranteeLettersCommonBalanceOverviewComponent', {
    templateUrl: require('./balanceOverview.component.html'),
    controller: BalanceOverviewController,
    controllerAs: 'vm',
    bindings: {
      serviceRequestId: '<',
      refreshTrigger: '<',
      newGuaranteeAmount: '=?',
      requestAmount: '=?',
      employeeAllowance: '=?',
      currencyCode: '<'
    }
  });

  BalanceOverviewController.$inject = ['abp.services.app.hostServiceRequest'];

  function BalanceOverviewController(hostServiceRequestSvc) {
    const vm = this;

    vm.$onChanges = onChanges;
    vm.getOrganizationNewBalance = getOrganizationNewBalance;
    vm.getMemberNewBalance = getMemberNewBalance;
    vm.getOrganizationNewGuaranteeAndCurrentLockedAmountChanges =
      getOrganizationNewGuaranteeAndCurrentLockedAmountChanges;
    vm.getMemberNewGuaranteeAndCurrentLockedAmountChanges =
      getMemberNewGuaranteeAndCurrentLockedAmountChanges;
    vm.defaultMaxAllowance = parseFloat(abp.setting.get("Hms.General.MaxAllowanceAmountLimit"));
    vm.loading = 0;
    vm.employeeAllowance = 0;
    vm.organization = null;
    vm.member = null;

    function onChanges(changes) {
      if (changes.serviceRequestId && changes.serviceRequestId.currentValue) {
        getBalanceOverview(vm.serviceRequestId);
      }

      if (changes.refreshTrigger
        && changes.refreshTrigger.currentValue
        && vm.serviceRequestId) {
        getBalanceOverview(vm.serviceRequestId);
      }
    }

    function getBalanceOverview(serviceRequestId) {
      vm.loading += 1;
      hostServiceRequestSvc.getBalanceOverview({
        id: serviceRequestId
      }).success((data) => {
        vm.requestAmount = data.requestAmount;
        vm.newGuaranteeAmount = data.newGuaranteeAmount;
        vm.organization = {
          currentAvailableAmount: data.organizationBalance.currentAvailableAmount,
          currentLockedAmount: data.organizationBalance.currentLockedAmount
        };
        vm.member = {
          currentAvailableAmount:
            Math.min(data.memberBalance.currentAvailableAmount, vm.defaultMaxAllowance),
          currentLockedAmount: data.memberBalance.currentLockedAmount,
          currentAllowance: data.memberBalance.currentAllowance,
        };

        vm.employeeAllowance = data.memberBalance.isUnlimitedAllowance
          ? Number.MAX_SAFE_INTEGER
          : vm.member.currentAllowance;
      }).finally(() => {
        vm.loading -= 1;
      });
    }

    function getOrganizationNewBalance() {
      if (vm.organization && !_.isNil(vm.organization.currentAvailableAmount)) {
        if (getOrganizationNewGuaranteeAndCurrentLockedAmountChanges() === 0) {
          return vm.organization.currentAvailableAmount;
        }

        const orgAvailable = vm.organization.currentAvailableAmount;
        const orgLocked = vm.organization.currentLockedAmount;
        return (orgAvailable + orgLocked) - vm.newGuaranteeAmount;
      }
      return null;
    }

    function getMemberNewBalance() {
      if (vm.member && !_.isNil(vm.member.currentAvailableAmount)) {
        const available = vm.member.currentAvailableAmount;
        const locked = vm.member.currentLockedAmount;
        return (available + locked) - vm.newGuaranteeAmount;
      }
      return null;
    }

    function getOrganizationNewGuaranteeAndCurrentLockedAmountChanges() {
      if (vm.organization && !_.isNil(vm.organization.currentLockedAmount)) {
        if (vm.organization.currentLockedAmount === 0)
          return 0;

        const amountDifference =
          vm.newGuaranteeAmount - vm.organization.currentLockedAmount;
        return amountDifference > 0 ? amountDifference : 0;
      }
      return 0;
    }
    function getMemberNewGuaranteeAndCurrentLockedAmountChanges() {
      if (vm.member && !_.isNil(vm.member.currentLockedAmount)) {
        if (vm.member.currentLockedAmount === 0)
          return 0;

        const amountDifference = vm.newGuaranteeAmount - vm.member.currentLockedAmount;
        return amountDifference > 0 ? amountDifference : 0;
      }
      return 0;
    }
  }
})();
